import { gql } from '@apollo/client';

// Operation names deliberately differ from the backend field names
// (lessonWhiteboard / groupWhiteboards) — equal names make codegen collapse
// the generated result type into the schema payload type.

export const LessonWhiteboardQuery = gql`
  query GetLessonWhiteboard($lessonId: ID!) {
    lessonWhiteboard(lessonId: $lessonId) {
      id
      name
      sceneJson
      sceneVersion
      createdAt
      updatedAt
      lessons {
        lessonId
        lessonName
        lessonNumber
        lessonDate
      }
      # Scene images live on S3, not inside sceneJson (spec 0010 rev.3).
      # url is a short-TTL presigned GET link — never cache it long-term.
      files {
        fileId
        mimeType
        url
      }
    }
  }
`;

export const WhiteboardLibraryQuery = gql`
  query GetWhiteboardLibrary {
    whiteboardLibrary {
      itemsJson
      version
    }
  }
`;

export const GroupWhiteboardsQuery = gql`
  query GetGroupWhiteboards($groupId: ID!) {
    groupWhiteboards(groupId: $groupId) {
      id
      name
      sceneVersion
      updatedAt
      lessons {
        lessonId
        lessonName
        lessonNumber
        lessonDate
      }
    }
  }
`;
